var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.893555,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#F6E003"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5003,
    cy: 40.3939,
    r: 35.8792,
    stroke: "black",
    strokeWidth: 0.658333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0833 30.5179V40.3929C46.0833 42.2033 47.5646 43.6846 49.375 43.6846H51.0208V55.2054C51.0208 56.1106 51.7615 56.8512 52.6667 56.8512C53.5719 56.8512 54.3125 56.1106 54.3125 55.2054V25.7944C54.3125 24.7246 53.3085 23.9346 52.2717 24.1814C48.7167 25.0537 46.0833 28.0656 46.0833 30.5179ZM37.8542 35.4554H34.5625V25.5804C34.5625 24.6752 33.8219 23.9346 32.9167 23.9346C32.0115 23.9346 31.2708 24.6752 31.2708 25.5804V35.4554H27.9792V25.5804C27.9792 24.6752 27.2385 23.9346 26.3333 23.9346C25.4281 23.9346 24.6875 24.6752 24.6875 25.5804V35.4554C24.6875 39.0927 27.6335 42.0387 31.2708 42.0387V55.2054C31.2708 56.1106 32.0115 56.8512 32.9167 56.8512C33.8219 56.8512 34.5625 56.1106 34.5625 55.2054V42.0387C38.1998 42.0387 41.1458 39.0927 41.1458 35.4554V25.5804C41.1458 24.6752 40.4052 23.9346 39.5 23.9346C38.5948 23.9346 37.8542 24.6752 37.8542 25.5804V35.4554Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/meal.a97cad2124d1e3f296a9094d7f90d8bf.svg";
export { ForwardRef as ReactComponent };